import styled from 'styled-components';

export const Image = styled.img`
  user-select: none;
  pointer-events: none;
`;
